<template>
	<el-container>
		<el-main style="width: 70%;">
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">单位信息</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
      <!--公司信息-->
			<div style="width: 100%;max-width: 800px;margin: 0 auto;" v-loading="diaLoading">
        <el-form label-width="90px" :model="editForm">
          <el-form-item label="单位名称:" style="margin-bottom: 10px;">
            <el-input v-model="editForm.name" clearable></el-input>
          </el-form-item>
          <el-form-item label="主营项目:" style="margin-bottom: 10px;">
            <el-input v-model="editForm.mainProject" type="textarea" clearable></el-input>
          </el-form-item>
          <el-form-item label="单位地址:" style="margin-bottom: 10px;">
            <el-input v-model="editForm.address" clearable></el-input>
          </el-form-item>
          <el-form-item label="所在城市:" style="margin-bottom: 10px;">
            <el-input v-model="editForm.city" clearable></el-input>
          </el-form-item>
          <el-form-item label-width="0" style="text-align: center;">
            <el-button type="primary" @click="getInfoSave">保存</el-button>
          </el-form-item>
        </el-form>
			</div>
		</el-main>
	</el-container>
</template>

<script>
  var defaultInfo ={
    webId:'',
    name:'',
    mainProject:'',
    address:'',
    city:''
  }
	export default {
		data() {
			return {
        editForm:JSON.parse(JSON.stringify(defaultInfo)),
        diaLoading:true,
			}
		},

		created() {
		},
		
		mounted() {
			this.getInfo()
		},

		methods: {
      //获取信息
			async getInfo() {
        var api = "/manager/projectinfo/getprojectinfo";
        const response =await this.util.postRequest({
          url: api,
          method: "POST",
          data: {},
        });
        console.log("*****querySelect *****", response);
        if (response.resultCode == 10000){
          this.diaLoading = false;
          this.editForm = response.data;
        }else{
          this.diaLoading = false;
          this.$message.error(response.desc);
        }
			},
      //信息更新保存
      async getInfoSave() {
        this.diaLoading = true;
        var api = "/manager/projectinfo/updateprojectinfo";
        const response =await this.util.postRequest({
          url: api,
          method: "POST",
          data: this.editForm,
        });
        console.log("*****querySelect *****", response);
        if (response.resultCode == 10000){
           this.$message.success("更新成功");
           this.getInfo();
        }else{
          this.$message.error(response.desc);
        }
      },
		}
	}
</script>

<style scoped="scoped">
	.custom_div {
		margin-bottom: 0.9375rem;
	}
	.custom_div > span  {
		font-size: 0.875rem;
		color: #444444;
	}
  .talkListBox{width: 100%;overflow: hidden;}
  .talkListBox dl{overflow: hidden;margin-bottom: 10px;}
  .talkListBox dl dt{width: 100%;height: 30px;background: #eee;padding: 0 20px;box-sizing: border-box;font-size: 14px;line-height: 30px;font-weight: bold;color:darkgreen;}
  .talkListBox dl dd.active{background: #f5f5f5;}
  .talkListBox dl dd{padding: 5px 20px;overflow: hidden;font-size: 13px;line-height: 25px;font-weight: normal;border-bottom: 1px #ddd dotted;}
  .talkListBox dl dd .title{color: #5A9CF8;font-weight: normal;}
  .talkListBox dl dd .log{color: blue;}
</style>
